import React from "react"

export const onClientEntry = () => {
  // This code runs on the client side when Gatsby starts up.
  // If you need to add any client-side scripts or do any client-side initialization,
  // you can do it here.
}
